import React, { memo, useMemo, useState } from 'react';

import { PiPlayFill } from 'react-icons/pi';

import VideoProcessing from '../../../../components/VideoPlayer/VideoProcessing/VideoProcessing';
import { checkIfUserIsCreator } from '../../../../shared/utils';

interface Props {
  postedBy?: string;
  mediaId: string;
  mediaUrl: string;
  transcodingJobId?: string;
  isCompressDone?: boolean;
  hasError?: boolean;
  errorDescription?: string;
  controls?: boolean;
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const PostMediaContentVideo: React.FC<Props> = ({
  postedBy,
  mediaId,
  mediaUrl,
  transcodingJobId,
  isCompressDone,
  hasError,
  errorDescription,
  controls,
  onClick,
  style,
  className,
}) => {
  const [isVideoReady, setIsVideoReady] = useState(isCompressDone || false);

  const isVideoOwner = useMemo(() => {
    return checkIfUserIsCreator(postedBy);
  }, [postedBy]);

  const renderContent = (children: React.ReactNode) => {
    return (
      <div
        onClick={onClick}
        className={`post-media__contents__item post-media__contents__item--video ${
          className || ''
        }`}
        style={{
          position: 'relative',
          ...style,
        }}>
        {children}
      </div>
    );
  };

  if (hasError) {
    return renderContent(
      <VideoProcessing
        showProcessingStatus={isVideoOwner}
        hasError={hasError}
        errorDescription={
          errorDescription === 'false' ? undefined : errorDescription
        }
      />,
    );
  }

  if (!isVideoReady) {
    return renderContent(
      <VideoProcessing
        transcodingJobId={transcodingJobId}
        showProcessingStatus={isVideoOwner}
        onProcessingComplete={() => setIsVideoReady(true)}
      />,
    );
  }

  return renderContent(
    <>
      <video
        src={mediaUrl}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: 0,
        }}
        key={mediaId}
        id={mediaId}
        controls={controls}
      />

      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '50%',
          padding: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <PiPlayFill
          style={{
            fontSize: '24px',
            color: 'white',
          }}
        />
      </div>
    </>,
  );
};

export default memo(PostMediaContentVideo);
